// extracted by mini-css-extract-plugin
export default {"Popover":"styles_Popover__se7cG","Header":"styles_Header__jSM6t","iconShield":"styles_iconShield__oy43G","Body":"styles_Body__VV1YD"};